import { getObjectValueByStringPath } from 'utils';

import { Order } from './types';

export function descendingComparator<T = any>(
  a: T,
  b: T,
  orderBy: keyof T,
): number {
  const rowA = getObjectValueByStringPath(a, orderBy as string);
  const rowB = getObjectValueByStringPath(b, orderBy as string);
  let compareA: any = Number(rowA);
  let compareB: any = Number(rowB);

  compareA = Number.isNaN(compareA) ? rowA : compareA;
  compareB = Number.isNaN(compareB) ? rowB : compareB;

  compareA = compareA ?? 0;
  compareB = compareB ?? 0;

  if (rowA === null || rowB === null) {
    return -1;
  }

  if (compareB < compareA) {
    return -1;
  }
  if (compareB > compareA) {
    return 1;
  }
  return 0;
}

export function getComparator<T = any>(
  order: Order,
  orderBy: keyof T,
): (a: T, b: T) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator<T>(a, b, orderBy)
    : (a, b) => -descendingComparator<T>(a, b, orderBy);
}

export function stableSort<T = any>(
  array: T[],
  comparator: (a: T, b: T) => number,
): T[] {
  const mappedArray: [T, number][] = array.map((item, index) => [item, index]);

  mappedArray.sort(([itemA, indexA], [itemB, indexB]) => {
    const order = comparator(itemA, itemB);

    if (order !== 0) {
      return order;
    }

    return indexA - indexB;
  });

  return mappedArray.map(([item]) => item);
}
